/**
 * VPC-only: when VITE_CDN_PROXY_HOST is set at build time, replace the CDN
 * origin hostname (default CloudFront) so the browser loads assets via storage2 on
 * the VPS; nginx then proxies to the real CDN (see vpc_deploy Ansible).
 */
function stripHost(h: string): string {
  return h.replace(/^https?:\/\//i, '').split('/')[0].split(':')[0];
}

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const proxyHost = stripHost(import.meta.env.VITE_CDN_PROXY_HOST || '');
const originHost = stripHost(
  import.meta.env.VITE_CDN_ORIGIN_HOST || 'd10be39bo9qswo.cloudfront.net',
);

export function rewriteAssetCdnUrl(
  url: string | undefined | null,
): string | undefined | null {
  if (!proxyHost || !url || typeof url !== 'string') return url;
  if (!url.includes(originHost)) return url;

  const reHttps = new RegExp(`https://${escapeRegExp(originHost)}`, 'gi');
  const reHttp = new RegExp(`http://${escapeRegExp(originHost)}`, 'gi');

  return url.replace(reHttps, `https://${proxyHost}`).replace(reHttp, `https://${proxyHost}`);
}
